import { ReportResourceType } from '@core/reports-types';
import type { ReportDashboardMetricOptions } from '@core/reports-types';
import type { IconName } from '@core/user-interface-legacy';

export interface MetricCategory {
  id: ReportResourceType;
  label: string;
}

export const METRIC_ICON_MAP: Record<string, IconName> = {
  // ATS metrics
  candidates: 'people',
  candidates_over_time: 'access-time',
  candidate_score: 'rating-thumbs-up-down',
  custom_time_based: 'access-time',
  disqualifications: 'block',
  disqualifications_over_time: 'access-time',
  evaluations: 'thumbs-up-down',
  evaluations_over_time: 'access-time',
  events: 'calendar-blank',
  events_over_time: 'access-time',
  time_spent_interviewing: 'calendar-blank',
  jobs: 'work',
  jobs_over_time: 'access-time',
  jobs_activity_over_time: 'access-time',
  job_open_time: 'work',
  hires: 'hired',
  hires_over_time: 'access-time',
  requisitions: 'nav-requisitions-outline',
  fill_rate: 'nav-requisitions-outline',
  dropoff_rate: 'block',
  proceed_rate: 'arrow-forward',
  pipeline_events: 'access-time',
  time_spent_in_stage: 'access-time',
  time_to_reach_stage: 'access-time',
  views: 'visibility',
  views_over_time: 'access-time',
  visits: 'nav-careershub',
  visits_over_time: 'access-time',
  visit_duration: 'access-time',
  bounce_rate: 'nav-careershub',
  applications: 'file-document',
  applications_over_time: 'access-time',
  application_form_drop_off_rate: 'file-document',
  application_conversion_rate: 'arrow-forward',
  pipeline_events_over_time: 'access-time',
  job_count_over_time: 'access-time',
  // HR metrics
  average_age: 'cake-birthday',
  average_salary: 'account-balance-wallet',
  average_tenure: 'access-time',
  employees: 'account-group',
  employees_over_time: 'access-time',
  growth_rate: 'trend-up',
  headcount_change: 'import-export',
  headcount_change_over_time: 'access-time',
  ic_to_manager_ratio: 'account-tree',
  joiners_over_time: 'access-time',
  leavers_over_time: 'access-time',
  new_hire_turnover_rate: 'timer-sand',
  retention_rate: 'account-check',
  total_salary: 'account-balance-wallet',
  turnover_rate: 'trend-down',
};

/**
 * The map is keyed by metric id, so a metric the backend adds before the
 * frontend knows about it would render without an icon. Fall back to a neutral
 * one so the picker stays visually consistent.
 */
export const DEFAULT_METRIC_ICON: IconName = 'chart-bar';

export const getMetricIcon = (metric: string): IconName =>
  METRIC_ICON_MAP[metric] ?? DEFAULT_METRIC_ICON;

export const getMetricCategory = (metric: ReportDashboardMetricOptions): MetricCategory => ({
  id: metric.resourceId,
  label: metric.resource,
});
